import { useEffect } from "react";
import Head from "next/head";
import Image from "next/image";

import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import MainHeader from "../components/MainHeader";
import MainFooter from "../components/MainFooter";
import DemoForm from "../components/forms/Form";

import { getCookie } from "cookies-next";

import fonts from "../styles/FontInter.module.css";
import mainTheme from "../components/mainTheme";
import styles from "../styles/Home.module.css";
import ExitModal from "../components/ExitModal";
import FormMini from "../components/forms/FormMini";

export default function TemplatePage({ utm }) {
  useEffect(() => {
    dataLayer.push({ event: "optimize.activate" });
  }, []);

  return (
    <ThemeProvider theme={mainTheme}>
      <Head>
        <title>Request a Demo - Elm Street</title>
        <meta
          name="description"
          content="Explore the 1st true productivity platform in real estate to capture, nurture &amp; convert leads."
        />
        <link rel="icon" href="/favicon.ico" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:site" content="@weareelmstreet" />
        <meta name="twitter:creator" content="@weareelmstreet" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://elmstreet.com/demo" />
        <meta property="og:title" content="Request a Demo - Elm Street" />
        <meta
          property="og:description"
          content="Explore the 1st true productivity platform in real estate to capture, nurture &amp; convert leads."
        />
        <meta property="og:image" content="https://elmstreet.com/og_images/elmstreetog.jpg" />
      </Head>
      <CssBaseline className={fonts} />
      <MainHeader />

      <ExitModal>
        <div
          style={{
            backgroundImage: "url('orangebg.webp')",
            backgroundPosition: "center",
            backgroundSize: "fixed",
            padding: "30px",
            display: "block",
          }}
        >
          <div style={{ textAlign: "center", paddingBottom: "20px" }}>
            {" "}
            <Typography
              variant="h3"
              component="h2"
              style={{ color: "#ffffff", textAlign: "center", paddingBottom: "10px" }}
            >
              Stay up to date...
            </Typography>
            <Typography variant="h5" component="h2" style={{ color: "#333666", textAlign: "center" }}>
              on the latest &amp; greatest in the industry. Be the first to know about:
            </Typography>
            <br />
            <strong>
              + Upcoming webinars with industry leaders
              <br />
              + The latest in marketing &amp; lead gen strategies
              <br />
              + Newly-published industry guides
              <br />
              + First dibs on educational boot camps &amp; seminars
              <br />
            </strong>
          </div>
          <div style={{ backgroundColor: "#ffffff", padding: "25px" }}>
            <FormMini
              buttonText="Register before you go"
              formName="es2_blog"
              listId="147953"
              utmOverride="exit_intent"
            />
          </div>
        </div>
      </ExitModal>

      <div
        style={{
          backgroundImage: "url('demobg.jpg')",
          backgroundPosition: "center",
          backgroundSize: "cover",
          display: "block",
        }}
      >
        <Container maxWidth="lg">
          <Grid container>
            <Grid item md={6} sm={12}>
              <div
                style={{
                  color: "#FFFFFF",
                  alignItems: "center",
                  display: "flex",
                  flexDirection: "row",
                  height: "400px",
                }}
              >
                <div>
                  <Typography variant="h2" component="h1">
                    EXPLORE YOUR
                    <br />
                    <span style={{ color: mainTheme.palette.secondary.main }}>ALL-IN-ONE </span>
                    <br />
                    SOLUTION FOR SUCCESS.
                  </Typography>
                  <p>
                    Experience a seamless way to attract leads, manage clients, and grow your business—all with one
                    partner. Book a demo today and see the difference for yourself.
                    <br />
                    <br />
                  </p>
                </div>
              </div>
            </Grid>
          </Grid>
        </Container>
      </div>

      <Container
        maxWidth="lg"
        style={{
          paddingLeft: "20px",
          paddingRight: "20px",
          marginTop: "65px",
          marginBottom: "65px",
        }}
      >
        <Grid container>
          <Grid item md={2} sm={12} xs={12} />
          <Grid item md={8} sm={12} xs={12}>
            <DemoForm
              successMsg={
                <div style={{ color: "#d37800" }}>
                  <strong>
                    We're Excited to Connect with You! A member of the Elm Street Technology team will be in touch with
                    you shortly.
                  </strong>
                  <br />
                  <br />
                </div>
              }
              formName="es2_demo"
              listId="147982"
              fieldList={["first_name", "last_name", "email", "phone", "roll", "solutions", "currentClient"]}
            />
          </Grid>
        </Grid>
      </Container>

      <MainFooter />
    </ThemeProvider>
  );
}

export const getServerSideProps = ({ req, res }) => {
  let cookies = getCookie("elmlead", { req, res });
  if (cookies) {
    return { props: { utm: cookies } };
  }
  return { props: {} };
};
